import { PaymentIntent } from "@stripe/stripe-js";

// Used to Create an Intent from the front end and pass back to capture or confirm
export class StripeIntent {
  publicKey: string;
  method: string;
  paymentIntent: PaymentIntent;
}

// Used to accept the return querystring parameters and process them
export class StripeRedirectReturn {
  action: string;
  intent: string;
  payment_intent: string;
  payment_intent_client_secret: string;
  redirect_status: string;
}
